import { render, staticRenderFns } from "./CatalogReservationConfigManual.vue.html?vue&type=template&id=5a0c46b4&"
import script from "./CatalogReservationConfigManual.component.js?vue&type=script&lang=vueJs&"
export * from "./CatalogReservationConfigManual.component.js?vue&type=script&lang=vueJs&"
import style0 from "./CatalogReservationConfigManual.scss?vue&type=style&index=0&prod&lang=vueScss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports